<template>
  <div class="main-page">
<!--    <nav>-->
<!--      <router-link to="/">Home</router-link> |-->
<!--      <router-link to="/about">About</router-link>-->
<!--    </nav>-->
    <Header></Header>
    <router-view class="router"/>
    <Info class="info"></Info>
<!--    <router-link></router-link>-->
<!--    <HomeView></HomeView>-->
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Info from "@/components/Info.vue";
// import {useStore} from "vuex";

export default {
  components: {Info, Header},
  mounted() {
    // const store = useStore()
    // console.log('app store',store)
  }
}
</script>

<style lang="less">
@font-face {
  font-family: 'MyCustomFont';
  src: url('~@/assets/PangMenZhengDaoBiaoTiTiMianFeiBan-2.ttf') format('truetype');
}
html,body,#app{
  height: 100%;
  font-family: "MyCustomFont" !important;
}
body {
  display: block;
  margin: 0px;
  font-family:"宋体",Arial,Helvetica,sans-serif,"宋体";
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  font-family: "MyCustomFont" !important;
}
.main-page {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .router {
    flex-grow: 1;
    min-height: calc(100% - 200px);
  }
  .info {
    position: relative;

    bottom: 0;
    width: 100%;
  }
}
</style>
